import brand from '@helpers/brand';
import { fluid } from '@helpers/fluid';
import fonts from '@helpers/fonts';
import { VariantTheme } from '@helpers/themeEnums';
import { link } from '@helpers/typography';
import styled from 'styled-components';
const Container = styled.ul `
  --breadcrumbColor: ${brand.global.black};
  padding: 4px 0;

  [data-variant-theme=${VariantTheme.Black}] &,
  [data-variant-theme=${VariantTheme.Teal}] & {
    --breadcrumbColor: ${brand.global.white};
  }
`;
const Item = styled.li `
  display: inline;
  margin-right: 10px;
  font-size: ${fluid(12, 14)};
  line-height: ${fluid(12, 16)};
  color: var(--breadcrumbColor);

  &:nth-last-child(2),
  &:last-child {
    display: inline;
  }

  &:not(:last-child) {
    &::after {
      content: '/';
      margin-left: 10px;
    }
  }
`;
const ItemLink = styled.a `
  ${link};
  ${fonts.aptos.extraBold};

  color: var(--breadcrumbColor);
  text-underline-offset: 1px;

  &:hover,
  &:focus {
    border-color: var(--breadcrumbColor);
    outline: none;
  }
`;
const CurrentItem = styled.span `
  ${fonts.aptos.regular};
`;
const BreadcrumbsStyles = {
    Container,
    Item,
    ItemLink,
    CurrentItem,
};
export default BreadcrumbsStyles;
